import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=2f953f42&"
import script from "./TextInput.vue?vue&type=script&lang=ts&"
export * from "./TextInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports